export default "__VITE_ASSET__5e144653__"